import { Component, ElementRef, OnInit } from '@angular/core';
import { OpenService } from '@app-services/open.service';
import { MarketPlacePersonalizationUtils } from '../shopkeeper-layout/marketplace-personalization';

@Component({
  selector: 'app-auth-layout',
  templateUrl: './auth-layout.component.html',
  styleUrls: ['./auth-layout.component.scss']
})
export class AuthLayoutComponent implements OnInit {

  constructor(private openService: OpenService, private elRef: ElementRef) {
    this.openService.getLayoutVars()
    .subscribe(layoutVars => {
      MarketPlacePersonalizationUtils.initCssVars(this.elRef, layoutVars);
    });
  }

  ngOnInit() {
  }

}
